module.exports = __webpack_public_path__ + "header-logo-aedf116d.svg";